var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "top-header__container",
      style: { background: _vm.promos.background }
    },
    [
      _c(
        "a",
        {
          staticClass: "top-header__inner-container container",
          style: { color: _vm.promos.color },
          attrs: { href: _vm.promoLink }
        },
        [
          _c("div", { staticClass: "top-bar__promobar-carousel" }, [
            _vm.promos.slides.length < 2
              ? _c(
                  "div",
                  { staticClass: "carousel--promobar" },
                  _vm._l(_vm.promos.slides, function(promo, index) {
                    return _c(
                      "div",
                      { key: index, staticClass: "promobar-block-container" },
                      [
                        _c("div", {
                          staticClass: "promobar-block-content",
                          domProps: { innerHTML: _vm._s(promo.promocontent) }
                        })
                      ]
                    )
                  }),
                  0
                )
              : _c(
                  "div",
                  {
                    staticClass: "carousel--promobar",
                    class: _vm.loading ? "loading" : ""
                  },
                  [
                    _vm.promos.arrows
                      ? _c(
                          "v-button",
                          {
                            staticClass: "carousel__nav__prev",
                            attrs: { label: "Previous Slide" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.$refs.promobarCarousel.slidePrev()
                              }
                            }
                          },
                          [
                            _c("icon", {
                              attrs: {
                                name: _vm.iconLeft,
                                color: _vm.promos.color
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "carousel",
                      {
                        ref: "promobarCarousel",
                        attrs: {
                          infinite: _vm.infiniteScroll,
                          "auto-play": true,
                          speed: _vm.promos.speed,
                          "slides-to-show": _vm.slidesToShow
                        },
                        on: {
                          "before-slide": _vm.beforeSlide,
                          "after-slide": _vm.afterSlide
                        }
                      },
                      _vm._l(_vm.promos.slides, function(promo, index) {
                        return _c("slide", { key: index }, [
                          _c("div", {
                            staticClass: "promobar-block-content",
                            domProps: { innerHTML: _vm._s(promo.promocontent) }
                          })
                        ])
                      }),
                      1
                    ),
                    _vm.promos.arrows
                      ? _c(
                          "v-button",
                          {
                            staticClass: "carousel__nav__next",
                            attrs: { label: "Next Slide" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.$refs.promobarCarousel.slideNext()
                              }
                            }
                          },
                          [
                            _c("icon", {
                              attrs: {
                                name: _vm.iconRight,
                                color: _vm.promos.color
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }